import React from 'react'

import { useSocket } from '@hooks'

const WebSocketIndicator: React.FC = () => {
  const { isConnected } = useSocket()

  return (
    <div className="websocket-indicator">
      <div className={`websocket-dot ${isConnected ? 'connected' : 'disconnected'}`} />
    </div>
  )
}

export default WebSocketIndicator
